export function isStorageBrand(name: string): boolean {
  const TOKENS: string[] = [
    "publicstorage",
    "psorange",
    "psstorage",
    "extraspacestorage",
    "extraspace",
    "lifestorage",
    "unclebobs",
    "cubesmart",
    "cubesmartselfstorage",
    "ustoreit",
    "istorage",
    "securcare",
    "securcareselfstorage",
    "northwestselfstorage",
    "moveitstorage",
    "blueskyselfstorage",
    "hideawaystorage",
    "guardianstorage",
    "personalministorage",
    "optivest",
  ];

  function sanitizeToLettersOnly(input: string): string {
    return (input ?? "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .replace(/[^a-z]/g, "");
  }

  const sanitized = sanitizeToLettersOnly(name);
  if (!sanitized) return false;

  for (const token of TOKENS) {
    if (sanitized.includes(token)) return true;
  }
  return false;
}
